import MuiButton from '@mui/material/Button';
import { styled } from '@mui/material/styles';

const colorCode = buttonColorType => {
  switch (buttonColorType) {
    case 'baby-blue':
      return '#92b4ff';
    case 'red':
      return '#f3655f';
    case 'green':
      return '#78D794';
    default:
      return '#92b4ff';
  }
};

const StyledButton = styled(MuiButton, {
  shouldForwardProp: prop => prop !== 'colortype',
})(({ colortype }) => ({
  color: '#f9f9f9',
  fontFamily: '"Source Sans Pro", sans-serif',
  letterSpacing: '0.2px',
  fontSize: 12,
  fontWeight: 600,
  borderRadius: 6,
  backgroundColor: colorCode(colortype),
  boxShadow: '0 0 20px 0 rgba(130, 167, 249, 0.2)',
  paddingLeft: 16,
  paddingRight: 16,
  '&:hover': {
    backgroundColor: colorCode(colortype),
  },
  '&:disabled': {
    color: '#CFCFCF',
    backgroundColor: '#E8E8E8',
  },
}));

function Button(props) {
  return (
    <StyledButton
      disableFocusRipple
      size="large"
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
    />
  );
}

export default Button;
